var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 0.5H21.375C21.9844 0.5 22.5 1.01562 22.5 1.625C22.5 2.28125 21.9844 2.75 21.375 2.75H4.125C3.04688 2.75 2.25 3.59375 2.25 4.625V17.375C2.25 18.4531 3.04688 19.25 4.125 19.25H19.875C20.9062 19.25 21.75 18.4531 21.75 17.375V9.125C21.75 8.09375 20.9062 7.25 19.875 7.25H5.625C4.96875 7.25 4.5 6.78125 4.5 6.125C4.5 5.51562 4.96875 5 5.625 5H19.875C22.125 5 24 6.875 24 9.125V17.375C24 19.6719 22.125 21.5 19.875 21.5H4.125C1.82812 21.5 0 19.6719 0 17.375V4.625C0 2.375 1.82812 0.5 4.125 0.5ZM18 14.75C17.1562 14.75 16.5 14.0938 16.5 13.25C16.5 12.4531 17.1562 11.75 18 11.75C18.7969 11.75 19.5 12.4531 19.5 13.25C19.5 14.0938 18.7969 14.75 18 14.75Z",
    fill: "#5954DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0ce27ca3bafb8bda70291e88703ed36c.svg";
export { ForwardRef as ReactComponent };